export default __webpack_public_path__ + "static/media/home_export_avatar.b0599ecc.svg";